import moment from "moment";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLazyViewModBusManufacturedDeviceBySerialKeyQuery } from "../../../../redux/api/mod-bus/modBusAPI";
import { IManufacturedDeviceView } from "../../../../shared/oversight-core/interfaces/manufactured-device-view";
import MaterialIcon from "../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import SpinnerModal from "../../../../shared/oversight-core/ui-elements/spinner/spinner";
import { showErrorMessage } from "../../../../shared/oversight-core/utils/toast";
import styles from "./manufactured-device-card.module.scss";

interface IProps {
  device: IManufacturedDeviceView;
}

const ManufacturedDeviceCard = (props: IProps) => {
  const { device } = props;

  const [collapsed, setCollapsed] = useState(false);
  const [connectionString, setConnectionString] = useState<string | null>(null);
  const [showConnectionString, setShowConnectionString] = useState(false);

  const [triggerViewManufacturedDevice, { isFetching }] =
    useLazyViewModBusManufacturedDeviceBySerialKeyQuery();

  const handleToggleConnectionString = (
    e: React.MouseEvent<HTMLSpanElement>,
  ) => {
    e.stopPropagation();

    if (showConnectionString) {
      setShowConnectionString(false);
      return;
    }

    triggerViewManufacturedDevice({ serialKey: device.deviceId })
      .unwrap()
      .then((res) => {
        setConnectionString(res.connectionString);
        setShowConnectionString(true);
      })
      .catch(() => {
        showErrorMessage("Loading connection string unsuccessful");
      });
  };

  return (
    <div
      className={`${styles.deviceContainer} bg-white p-3 rounded-3 cursor-pointer`}
      onClick={() => setCollapsed((ps) => !ps)}
    >
      <Row className="align-items-center justify-content-between">
        <Col className="col-5 col-sm-7">
          <Row className="align-items-center">
            <Col className="text-dark font-weight-500 font-size-14">
              {device.deviceId}
            </Col>
          </Row>
        </Col>
        <Col className="col-auto">
          <MaterialIcon
            icon={collapsed ? "keyboard_arrow_down" : "keyboard_arrow_right"}
            color="#AEBBD0"
            size={25}
          />
        </Col>
      </Row>
      {collapsed && (
        <div className="ms-4 ps-3 mt-4">
          <Row className="text-light font-size-12">
            <Col className="col-12 mb-2">
              <span className="font-weight-500 text-dark">
                Manufactured Date&nbsp;:&nbsp;
              </span>
              {moment(device.manufacturedDate).format("DD/MM/YYYY")}
            </Col>
            <Col className="col-12">
              <Row className="align-items-center">
                <Col className="col-auto pe-0">
                  <span className="font-weight-500 text-dark">
                    Connection String&nbsp;:
                  </span>
                </Col>
                <Col className="col-auto ps-2 pe-0">
                  {isFetching ? (
                    <SpinnerModal size="sm" show={true} withOverlay={false} />
                  ) : showConnectionString && connectionString ? (
                    connectionString
                  ) : (
                    "••••••••••••••••"
                  )}
                </Col>
                <Col className="col-auto">
                  <MaterialIcon
                    icon={
                      showConnectionString ? "visibility" : "visibility_off"
                    }
                    color="#69768B"
                    size={18}
                    className="cursor-pointer"
                    onClick={handleToggleConnectionString}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default ManufacturedDeviceCard;
